<template>
  <div class="copyright-page">
    <p class="title">版权说明</p>
    <p class="text">
      1、本网站刊载的所有内容，包括但不限于文字报道、图片、视频、音频等，均受《中华人民共和国著作权法》、《中华人民共和国商标法》、《中华人民共和国专利法》及适用之国际公约中有关著作权、商标权、专利权以及或其它财产所有权法律的保护，相应的版权或许可使用权均属本网站所有;<br />
      <br />
      2、凡未经一席授权，任何媒体、网站及个人不得转载、复制、重制、改动、展示或使用一席网站的局部或全部的内容或服务，或在非一席网站所属服务器上建立镜像。如果已转载，请自行删除。同时，我们保留进一步追究相关行为主体的法律责任的权利。可联系微信yixixiaobian协商转载事宜;<br />
      <br />
      3、已经本网站授权使用的，应按照授权合同所规定条款使用。<br />
    </p>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.copyright-page {
  padding: 40px 50px;
}
.title {
  font-size: 16px;
  font-weight: bold;
  margin: 0 0 10px;
}
.image {
  display: block;
}
.text {
  font-size: 14px;
  color: #333;
  line-height: 24px;
}
</style>
